<script setup>
import MediaPressLogo from "@/Components/MediaPressLogo.vue";
import {Head, usePage} from '@inertiajs/inertia-vue3';
import {computed, ref} from "vue";

const props = defineProps({
    video: String,
    videoPoster: String,
})

const active = ref(false);

const app = computed(() => {
    return usePage().props.value.app;
});

const profile = computed(() => {
    return usePage().props.value.profile;
})

const introText = computed(() => {
    return usePage().props.value.introText;
})

active.value = true;

</script>

<template>
    <div class="h-screen flex items-stretch overflow-hidden relative">
        <Head>
            <title>{{ app.pageTitle }}</title>
        </Head>



        <div class="w-full lg:w-6/12 p-20 lg:p-32">
            <div class="w-64 mb-10">
                <slot name="logo">
                    <template v-if="!!profile && profile.has_logo">
                        <figure>
                            <img :src="profile.logo_url" :alt="profile.title + ' Logo'" class="max-h-28" />
                        </figure>
                    </template>
                    <template v-else-if="app.logo.dark">
                        <figure>
                            <img :src="app.logo.dark" :alt="app.name" />
                        </figure>
                    </template>
                    <template v-else>
                        <MediaPressLogo />
                    </template>
                </slot>
            </div>
            <div class="w-full lg:w-11/12 xl:w-10/12">
                <slot name="body" />
            </div>
        </div>
        <div class="absolute right-10 bottom-10 z-10" v-if="!profile">
            <h2 class="font-bold hidden lg:block lg:text-5xl xl:text-6xl 2xl:text-7xl text-right text-white" v-html="introText">
            </h2>
        </div>

        <div class="hidden lg:block lg:w-6/12 overflow-hidden relative transform rotate-6 scale-125">
            <transition name="video-slide">
                <div
                    v-if="active"
                    class="w-full absolute left-0 top-0 bottom-0 overflow-hidden"
                >
                    <div
                        v-if="profile && profile.has_welcome"
                        class="absolute left-0 right-0 top-0 bottom-0 bg-center bg-cover"
                        :style="{
                            backgroundImage: 'url(' + profile.welcome_url + ')',
                        }"
                    ></div>
                    <template v-else>
                        <div class="video h-full max-w-none">
                            <video :src="video" :poster="videoPoster" loop muted autoplay class="h-full max-w-none -translate-x-1/4"></video>
                        </div>
                    </template>
                </div>
            </transition>
        </div>
    </div>
</template>

<style scoped>

.video-slide-enter-active {
    @apply transform transition-all duration-2000 ease-out;
}

.video-slide-enter-from {
    @apply translate-x-4 opacity-0;
}

.video-slide-enter-to {
    @apply translate-x-0 opacity-100;
}
</style>
